export default function getUrlParameter(name, history) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  const results = regex.exec(history.location.search);
  return results === null
    ? false
    : decodeURIComponent(results[1].replace(/\+/g, ' '));
}
